export interface AnimalLetter {
  letter: string;
  animal: string;
}

export const englishAnimals: AnimalLetter[] = [
  { letter: 'A', animal: 'Ant' },
  { letter: 'B', animal: 'Butterfly' },
  { letter: 'C', animal: 'Cat' },
  { letter: 'D', animal: 'Dog' },
  { letter: 'E', animal: 'Elephant' },
  { letter: 'F', animal: 'Frog' },
  { letter: 'G', animal: 'Giraffe' },
  { letter: 'H', animal: 'Horse' },
  { letter: 'I', animal: 'Iguana' },
  { letter: 'J', animal: 'Jaguar' },
  { letter: 'K', animal: 'Kangaroo' },
  { letter: 'L', animal: 'Lion' },
  { letter: 'M', animal: 'Monkey' },
  { letter: 'N', animal: 'Narwhal' },
  { letter: 'O', animal: 'Owl' },
  { letter: 'P', animal: 'Penguin' },
  { letter: 'Q', animal: 'Quokka' },
  { letter: 'R', animal: 'Rabbit' },
  { letter: 'S', animal: 'Snake' },
  { letter: 'T', animal: 'Tiger' },
  { letter: 'U', animal: 'Unicornfish' },
  { letter: 'V', animal: 'Vicuña' },
  { letter: 'W', animal: 'Whale' },
  { letter: 'X', animal: 'X-ray Fish' },
  { letter: 'Y', animal: 'Yak' },
  { letter: 'Z', animal: 'Zebra' }
];

export const spanishAnimals: AnimalLetter[] = [
  { letter: 'A', animal: 'Abeja' },
  { letter: 'B', animal: 'Ballena' },
  { letter: 'C', animal: 'Cocodrilo' },
  { letter: 'D', animal: 'Delfín' },
  { letter: 'E', animal: 'Elefante' },
  { letter: 'F', animal: 'Foca' },
  { letter: 'G', animal: 'Gato' },
  { letter: 'H', animal: 'Hipopótamo' },
  { letter: 'I', animal: 'Iguana' },
  { letter: 'J', animal: 'Jirafa' },
  { letter: 'K', animal: 'Koala' },
  { letter: 'L', animal: 'León' },
  { letter: 'M', animal: 'Mariposa' },
  { letter: 'N', animal: 'Narval' },
  { letter: 'Ñ', animal: 'Ñandú' },
  { letter: 'O', animal: 'Oso' },
  { letter: 'P', animal: 'Pingüino' },
  { letter: 'Q', animal: 'Quetzal' },
  { letter: 'R', animal: 'Rana' },
  { letter: 'S', animal: 'Serpiente' },
  { letter: 'T', animal: 'Tortuga' },
  { letter: 'U', animal: 'Urraca' },
  { letter: 'V', animal: 'Vaca' },
  { letter: 'W', animal: 'Wombat' },
  { letter: 'X', animal: 'Xenopus' },
  { letter: 'Y', animal: 'Yak' },
  { letter: 'Z', animal: 'Zorro' }
];
